/**
 * created by athukorala on 10/16/19
 */
import React, {Component} from 'react';
import './ForgotPassword.css'
import '../Login.css'
import {Form, Icon, Input} from "semantic-ui-react";
import {Button, CardBody, Col, Row} from "reactstrap";
import * as EmailValidator from "email-validator";
import * as common from "../../../const/Common/CommonFunc";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import Cookies from "js-cookie";
import axios_tag from "../../../axios/axios_tag";
// import swal from "sweetalert";
// import success_icon from "../../../assets/img/sweet/success.svg";
// import Lbl from "../../../components/Label/Lbl";
// import DrpDwn from "../../../components/Dropdown/Dropdown/DrpDwn";
import apiConfig from "../../../axios/axios_api_services";

class App extends Component {
  state = {
    email: "",
    pinCode: '',
    sendMail: false,
    re_password: '',
    password: '',
  };
  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };
  viewPassword = () => {
    let i = document.getElementById("password-field");
    if (i.type === "password") {
      i.type = "text"
    } else {
      i.type = "password"
    }
  };
  resetPasswordHandler = () => {
    const {password, re_password, pinCode} = this.state;
    let passwordReg = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{9,}$)");

    let condition = false;
    pinCode.trim() === "" ? common.notifyMessage("Please enter pin code") :
      password.trim() === "" ? common.notifyMessage("Please enter new password") :
        re_password.trim() === "" ? common.notifyMessage("Please re-enter new password") :
          password.trim() !== re_password.trim() ? common.notifyMessage("Passwords do not match") :
            !passwordReg.test(password.trim()) ? common.notifyMessage("Password must contain at least 9 characters, including UPPER/LOWERCASE/SPECIAL_CHARACTER and NUMBERS") :

              condition = true;

    if (condition) {
      this.props.spinnerHandler(true);
      axios_tag.post(apiConfig.FORGOT_PASSWORD, {
        email: this.state.email.trim(),
        pin: pinCode.trim(),
        password: re_password.trim()
      })
        .then(response => {
          if (response.data.success) {
            common.warningAlert(response.data.message, 0);
            this.props.backToSigninFunc();
          } else {
            common.warningAlert(response.data.message, 1)
          }
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.resetPasswordHandler();
          }
        })
        .finally(fin => {
          this.props.spinnerHandler(false);
        })
    }
  };

  render() {
    return this.state.sendMail ?
      <CardBody>
        <h1>Forgot Password</h1>
        <p className="text-muted">We've sent a password reset verification code to your email address. Enter
          verification code and new password</p>
        <Input
          style={{width: '100%'}}
          icon='code'
          iconPosition='right'
          label={{tag: false, icon: 'code'}}
          labelPosition='left'
          placeholder='Enter pin code'
          value={this.state.pinCode}
          onChange={this.handleChange("pinCode")}
        />
        <br/><br/>
        <Form>
          <Col className={"none-padding forgot-psw-psw-feilds"} lg={12}>
            <Input id={"password-field"} type={"password"}
                   onChange={this.handleChange('password')}
                   value={this.state.password}
                   style={{width: '100%'}}
                   icon={<Icon onMouseUp={() => this.viewPassword(false)}
                               onMouseDown={() => this.viewPassword(true)} name='eye' circular link/>}
                   iconPosition='right'
                   labelPosition='left'
                   label={{tag: false, icon: 'lock'}}
                   placeholder='Enter new password'/>
          </Col>
          <Col className={"none-padding forgot-psw-psw-feilds"} lg={12}>
            <Input id={"password-field_"} type={"password"}
                   onChange={this.handleChange('re_password')}
                   value={this.state.re_password}
                   labelPosition='left'
                   label={{tag: false, icon: 'lock'}}
                   style={{width: '100%'}}
                   placeholder='Re-enter new password'/>
          </Col>
        </Form>

        <Row>
          <Col xs="6">
            <p className={"login-right-side-forgot-password_"} onClick={this.sendMailHandler}>{"Re-send email"}</p>
          </Col>
          <Col xs="6" style={{textAlign: 'right'}}>
            <Button onClick={this.resetPasswordHandler} className="ui button px-5 forgot-password-btn"
                    style={{padding: '0px!important'}}>Reset password</Button>
          </Col>
        </Row>
      </CardBody>
      :
      <CardBody>
        <h1>Forgot Password</h1>
        <p className="text-muted">Enter your email address first to get a verification code</p>
        <Input
          style={txtStyle}
          icon='envelope'
          iconPosition='left'
          label={{tag: true, content: 'Email'}}
          labelPosition='right'
          placeholder='Enter Email'
          onChange={this.handleChange("email")}
        />

        <Row>
          <Col xs="6">
            <p className={"login-right-side-forgot-password_"} onClick={this.props.backToSigninFunc}>{"Back"}</p>

          </Col>
          <Col xs="6" style={{textAlign: 'right'}}>
            <Button onClick={this.sendMailHandler} className="ui button px-5 forgot-password-btn">Next</Button>
          </Col>
        </Row>
      </CardBody>
  }

  sendMailHandler = () => {
    let condition = false;
    !EmailValidator.validate(this.state.email.trim()) ? common.notifyMessage("Please enter valid email address") : condition = true;
    if (condition) {
      this.props.spinnerHandler(true);

      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
      };
      // , {headers: headers}

      axios_tag.post(apiConfig.FORGOT_PASSWORD_REQUEST, {email: this.state.email.trim()})
        .then(response => {
          if (response.data.success) {
            common.warningAlert(response.data.message, 0);
            this.setState({
              sendMail: true
            })
          } else {
            common.warningAlert(response.data.message, 1);
          }
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.sendMailHandler();
          }
        })
        .finally(fin => {
          this.props.spinnerHandler(false);
        })
    }
  }
}

let txtStyle = {
  marginBottom: '10px',
  height: '45px',
  width: '100%'
};
const mapStateToProps = (state) => ({
  is_spin: state.spinnerReducer.is_spin,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
